module.exports = __webpack_public_path__ + "img/1501986643.a6260f99.jpg";